import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import PartnersSection from '../components/home/PartnersSection';
import ServicesSection from '../components/home/ServicesSection';
import AboutSection from '../components/home/AboutSection';
import CaseStudiesSection from '../components/home/CaseStudiesSection';
import WorkingProcessSection from '../components/home/WorkingProcessSection';
import TechnologiesSection from '../components/home/TechnologiesSection';
import GlobalImpactSection from '../components/home/GlobalImpactSection';
import ArticlesSection from '../components/home/ArticlesSection';
import ContactSection from '../components/home/ContactSection';
import { Toaster } from '../components/ui/toaster';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <PartnersSection />
        <ServicesSection />
        <AboutSection />
        <CaseStudiesSection />
        <WorkingProcessSection />
        <TechnologiesSection />
        <GlobalImpactSection />
        <ArticlesSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default HomePage;
